import chain from '@/lib/axios-chain'
import {
  decodeInqueryList,
  decodeInqueryDetail,
  decodeInqueryHistoryDetail
} from '@/lib/mix-utils'

/* export const inqueryList = () => chain.create('/inquiry/manager/search')

export const getAddInqueryConfig = () => chain.create('/inquiry/public/config')

export const getInqueryDetail = () => chain.create('/inquiry/manager/content') */

// new
// 获取初始化表单
export const getConfig = () => chain.create('/inquiry/inquiry/getconfig', 'get')

// 录入信息
export const addInquiry = () => chain.create('/inquiry/inquiry/add', 'post')

// 审核信息列表
export const auditList = () =>
  chain
    .create('/inquiry/audit/index', 'get')
    .decode(async (payload, decode) => {
      const datas = await decodeInqueryList(payload)
      return datas
    })

/* export const auditListDecode = () =>
  chain.create('path/to/foo/bar', 'post').decode(async (payload, decode) => {
    payload.field1 = decode(payload.field1)
    // 返回解密后的payload数据供后续函数使用
    return payload
  }) */

// 获取信息查重配置
export const checkRepeatConfig = () =>
  chain.create('/inquiry/checkrepeat/config', 'get')

// 信息查重列表
export const checkRepeatList = () =>
  chain.create('/inquiry/checkrepeat/index', 'get').decode(async payload => {
    const datas = await decodeInqueryList(payload)
    return datas
  })

// 询盘信息列表
export const inquiryList = () =>
  chain.create('/inquiry/list/index', 'get').decode(async payload => {
    // console.time('decode time')
    const datas = await decodeInqueryList(payload)
    // console.timeEnd('decode time')
    return datas
  })
// 询盘列表字段设置宽度
export const setInquiryListColumnWidth = () =>
  chain.create('/inquiry/config/setlistwidth', 'post')

export const inquiryFilterList = () =>
  chain.create('/inquiry/search/index', 'post').decode(async payload => {
    const datas = await decodeInqueryList(payload)
    return datas
  })

export const inquiryListConfig = () =>
  // chain.create('/inquiry/list/config1', 'get')
  chain.create('/inquiry/list/config', 'get')

// 设置tab配置
// export const setTab = () => chain.create('/inquiry/config/settab', 'post')

// 获取tab配置
// export const getTab = () => chain.create('/inquiry/config/gettab', 'get')

// 设置查询配置
export const setQuery = () => chain.create('/inquiry/config/setquery', 'post')

// 获取查询配置
export const getQuery = () => chain.create('/inquiry/config/getquery', 'get')

// 获取导出配置
export const getExport = () => chain.create('/inquiry/config/getexport', 'get')

// 设置导出配置
export const setExport = () => chain.create('/inquiry/config/setexport', 'post')

// 信息详情
export const inquiryDetail = () =>
  chain.create('/inquiry/inquiry/detail', 'get').decode(async payload => {
    const datas = await decodeInqueryDetail(payload)
    return datas
  })

// 信息编辑
export const inquiryEdit = () => chain.create('/inquiry/inquiry/edit', 'post')

// 领取信息
export const inquiryReceive = () =>
  chain.create('/inquiry/inquiry/receive', 'post')

// 指派信息
export const inquiryAssign = () =>
  chain.create('/inquiry/inquiry/assign', 'post')

// 转移信息
export const inquiryTransfer = () =>
  chain.create('/inquiry/inquiry/transfer', 'post')

// 分配信息
export const inquiryAllocate = () =>
  chain.create('/inquiry/inquiry/allocate', 'post')

// 申请重新分配
export const inquiryApply = () => chain.create('/inquiry/inquiry/apply', 'post')

// 信息删除
export const inquiryDelete = () => chain.create('/inquiry/inquiry/del', 'post')

// 询盘信息归档
export const inquiryArchive = () =>
  chain.create('/inquiry/inquiry/archive', 'post')

// 同步询盘至小满
export const inquirySyncxiaoman = () =>
  chain.create('/inquiry/inquiry/syncxiaoman', 'post')
// 同步回访记录至小满
export const followupSyncxiaoman = () =>
  chain.create('/inquiry/followup/syncxiaoman', 'post')

// 审核通过
export const inquiryApproval = () =>
  chain.create('/inquiry/audit/approval', 'post')

// 审核拒绝
export const inquiryReject = () => chain.create('/inquiry/audit/reject', 'post')

// 设置回访提醒
export const inquiryAddRemind = () =>
  chain.create('/inquiry/inquiry/addremind', 'post')

// 清除回访提醒
export const inquiryDelRemind = () =>
  chain.create('/inquiry/inquiry/delremind', 'post')

// 添加回访记录
export const inquiryAddFollowup = () =>
  chain.create('/inquiry/followup/add', 'post')
// 回访回复
export const inquiryReplyFollowup = () =>
  chain.create('/inquiry/followup/reply', 'post')
// 删除回访记录
export const inquiryDelFollowup = () =>
  chain.create('/inquiry/followup/del', 'post')
// 删除回访回复
export const inquiryDelFollowupReply = () =>
  chain.create('/inquiry/followup/delReply', 'post')

// 获取回访记录列表
export const inquiryFollowupList = () =>
  chain.create('/inquiry/followup/index', 'get')

// 添加评论
export const inquiryAddComment = () =>
  chain.create('/inquiry/comment/add', 'post')
// 获取评论列表
export const inquiryCommentList = () =>
  chain.create('/inquiry/comment/index', 'get')
// 回复评论
export const inquiryCommentReply = () =>
  chain.create('/inquiry/comment/reply', 'post')
// 评论删除
export const inquiryDelComment = () =>
  chain.create('/inquiry/comment/delComment', 'post')
// 删除评论的回复
export const inquiryDelCommentReply = () =>
  chain.create('/inquiry/comment/delReply', 'post')
// 获取变更历史列表
export const inquiryHistoryList = () =>
  chain.create('/inquiry/history/index', 'get')

// 获取变更历史详情
export const inquiryHistoryDetail = () =>
  chain.create('/inquiry/history/detail', 'get').decode(async payload => {
    const datas = await decodeInqueryHistoryDetail(payload)
    return datas
  })

// 导出信息
export const inquiryExport = () =>
  chain.create('/inquiry/export/index', 'post').decode(async payload => {
    const datas = await decodeInqueryList(payload)
    return datas
  })

// 每个表单项更新数据时查重
export const checkRepeat = () => chain.create('/inquiry/inquiry/checkrepeat', 'get')
// 获取字段配置数据
export const getFields = () => chain.create('/inquiry/config/getlist', 'get')
// 设置字段配置
export const setFields = () => chain.create('/inquiry/config/setlist', 'post')

// 获取分配依据
export const getAssignUseField = () => chain.create('/config/getAssignUseField', 'get')

// 获取经纬度
export const getInquiryGeo = () => chain.create('/inquiry/inquiry/geo', 'get')

// 修改来源
export const updateInquiryFromInfo = () => chain.create('/inquiry/inquiry/editfrom', 'post')

// 获取经纬度
export const getArchiveTypes = () => chain.create('/inquiry/inquiry/archivesetoptions ', 'get')

// 修改来源
export const editReceptMethod = () => chain.create('/inquiry/inquiry/editreception', 'post')

// 询盘列表视图
export const getView = () => chain.create('/inquiry/view/index', 'get')
